module.exports = __webpack_public_path__ + "media/images/products/longlife/icon-img-cost-3b291bfcf791e18d7c648e036debeb85.svg";